import React, { useEffect, useRef } from 'react';

const Result = ({ office, searchTerm, resourcedTexts, toggleSelected, selected }) => {
    const resultRef = useRef();

    useEffect(() => {
        const isSelected = office.id === selected;
        if (isSelected) {
            scrollToResult();
        }
    }, [selected]);

    const scrollToResult = () => {
        const parentEl = resultRef.current.parentElement;
        parentEl.scrollTo({
            top: resultRef.current.offsetTop,
        });
    };

    const officeRouteUrl = () => {
        return (
            `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                `${office.latitude},${office.longitude}`,
            )}` +
            (office.placeId ? `&destination_place_id=${encodeURIComponent(office.placeId)}` : '') +
            (searchTerm ? `&origin=${encodeURIComponent(searchTerm)}` : '')
        );
    };

    const distance = () => {
        return Math.round((office.distance / 1000) * 10) / 10;
    };

    return (
        <div className={`result ${selected === office.id ? 'selected' : ''}`} ref={resultRef}>
            <button className="result__intro" onClick={() => toggleSelected(office)} type="button">
                <div className="result__intro-heading">
                    <div className="marker" />
                    <h2>{office.name}</h2>

                    {office.distance && (
                        <span className="distance">
                            {distance()} {resourcedTexts.distanceSuffix}
                        </span>
                    )}

                    {selected === office.id ? (
                        <span className="chevron chevron__up" />
                    ) : (
                        <span className="chevron chevron__down" />
                    )}
                </div>

                <p>{office.address}</p>
            </button>

            <div className={`result__content ${selected === office.id ? 'active' : ''}`}>
                {office.phoneNumber && (
                    <a href={`tel:${office.phoneNumber}`} className="phone-number">
                        <span className="sec-icon sec-icon-phone" />
                        {office.phoneNumber}
                    </a>
                )}

                <div className="divider" />

                <a href={office.appointmentUrl} target="_blank" className="button button-icon-text">
                    <span className="sec-icon sec-icon-calendar" />
                    {resourcedTexts.makeAppointmentText}
                </a>

                <a href={office.url} className="button button-outline--purple">
                    {resourcedTexts.goToOfficeText}
                </a>

                <a
                    href={officeRouteUrl()}
                    className="route"
                    target="_blank"
                    rel="nofollow noreferrer"
                >
                    <span className="sec-icon sec-icon-route" />
                    {resourcedTexts.planRoute}
                </a>
            </div>
        </div>
    );
};

export default Result;
